// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__LlvHM","content":"LayoutSettings_content__1Z4L5"};